import fetch from "lib/fetch";
import type { PetTypeInterface } from "types/reference";

type PetTypeListResponse = { data: Array<PetTypeInterface> };

export const getPetTypesRequest = (languageCode: string) =>
    fetch.get<PetTypeListResponse>(`reference/pet_type/${languageCode}`);
